import { ExploreBlockType } from '@addmile/backend-client';

export type FieldKey =
  | 'title'
  | 'slug'
  | 'type'
  | 'imageUrl'
  | 'intro'
  | 'content'
  | 'generateAudio'
  | 'author'
  | 'videoUrl'
  | 'details'
  | 'showFeedback'
  | 'status'
  | 'personalizations'
  | 'language'
  | 'collections';

export const requiredFieldsByType: Partial<Record<ExploreBlockType, Set<FieldKey>>> = {
  [ExploreBlockType.Action]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'imageUrl',
    'content',
    'generateAudio',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.Video]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'imageUrl',
    'videoUrl',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.Article]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'imageUrl',
    'content',
    'generateAudio',
    'author',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.Practice]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'intro',
    'imageUrl',
    'content',
    'generateAudio',
    'author',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.Reflect]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'intro',
    'imageUrl',
    'content',
    'generateAudio',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.Quiz]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'intro',
    'imageUrl',
    'content',
    'generateAudio',
    'author',
    'details',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.MythBuster]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'intro',
    'imageUrl',
    'content',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
  [ExploreBlockType.MissingPiece]: new Set<FieldKey>([
    'title',
    'slug',
    'type',
    'intro',
    'imageUrl',
    'content',
    'showFeedback',
    'status',
    'personalizations',
    'language',
    'collections',
  ]),
};
